import { Form, FormGroup, Nav, Well } from 'react-bootstrap';
import styled from 'styled-components';

export const GridWrapper = styled.div`
    height: 68vh;
    width: 100%;

    @media (max-height: 1080px) {
        height: 62vh;
    }

    .action-menu {
        overflow: visible;
        border-bottom: none;
        line-height: 23px;
        border-color: #ccc;
    }

    .action-menu.ag-cell-focus {
        border-top: 1px solid #ccc !important;
        border-right: 1px solid white !important;
        border-bottom: 1px solid white !important;
        border-left: 1px solid #ccc !important;
    }

    .ag-header {
        //background-color: #133366;
        background-color:  #ddd;
        // color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
        font-weight: bold;
    }

    .ag-header-cell {
        display: flex;
        justify-content: center;
    }

    .ag-header-cell > .ag-cell-label-container > .ag-header-cell-label {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
    }

    .ag-header-cell > .ag-react-container {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .ag-header-cell > .ag-react-container > div {
        text-align: center;
    }

    .ag-cell {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-cell {
        border-bottom: none;
        text-align: center;
        line-height: 33px;
        border-color: #ccc;
        // font-size: 12px;
    }

    .list-cell-order {
        border-left-color: transparent;
    }

    .ag-header {
        color: white;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-family: Roboto;
    }

    .ag-header-row {
        background-color: lightgray;
    }

    .ag-body-viewport {
        border-left: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
        border-right: 1px solid #ccc;
    }

    .ag-row {
        z-index: 0;
    }

    .ag-row.ag-row-hover {
        background-color: #eaf2fa;
    }

    .ag-row.within-3-days.ag-row-hover {
        background-color: #eaf2fa;
        color: black;
    }

    .ag-row.ag-row-focus {
        z-index: 1;
    }

    .list-header {
        display: flex;
        justify-content: center;
        align-items: flex-end;
        padding-bottom: 4px;
        border-color: #eee;
        border-width: 1px 1px 0px 0px;
        border-style: solid;
    }

    .dropdown > .dropdown-toggle {
        font-size: ${p => p.fontSize ? p.fontSize : '12px'};
    }

    .dropdown-menu > li > a:hover, .dropdown-menu > li > a:focus {
        background-color: #ddd;
    }

    .remote-center {
        color: red;
    }

    .within-3-days {
        background-color: #C00;
        color: white;
    }

    .within-3-days .serology-details {
        color: white !important;
    }

    .within-3-days .remote-center {
        color: lightgrey !important;
    }

    .within-5-days {
        background-color: #FF0;
    }

    @media (max-width: 1920px) {
        font-size: 12px;
    }
`;

export const NavWrapper = styled(Nav)`
    // border-bottom: 0.5px solid #337ab7;

    & > li {
        //height: 52px;
    }

    & > li > a {
        font-size: 14px;
        font-weight: 500;
        // background-color: #337ab7;
        // color: white;
        // width: 160px;
        text-align: center;
        // line-height: 15px;
        padding: 5px 15px;
        height: 100%;
        display: flex;
        justify-content: center;
    }

    & > li > a:hover {
        background-color: #a0c5e5;
        color: black;
    }

    & > li > a.action {
        background-color: white;
        color: black;
    }

    & > li.active > a {
        background-color: #337ab7;
        color: white;
        // font-size: 14px;
        // line-height: 15px;
        // padding: 5px 7.5px;
    }

    @media (max-width: 1823px) {
        & > li > a,
        & > li.active > a {
            // font-size: 12px;
            min-width: 120px;
        }
    }
`;


export const FilterWrapper = styled(Well)`
    @media screen and (max-width: 1877px) {
        font-size: 12px;

        input.form-control {
            font-size: 12px;
        }

        input[name=email] {
            width: 180px !important;
        }

        input[name=birthDate] {
            width: 80px !important;
        }
    }
`;


export const ViewWrapper = styled(Form)`
    width: 98%;
    
    .modal-container {
        position: relative;
    }

    .modal-container .modal, .modal-container .modal-backdrop {
        position: absolute;
    }
`;

export const FormGroupWrapper = styled(FormGroup)`
    margin-bottom: 5px;
    // display: flex;
    // align-items: center;

    // & > .col-lg-3 {
    //     padding-left: 0px;
    // }
`;